module.exports = __webpack_public_path__ + "static/media/masterCardIcon.96add310.png";